import { render } from "./AcademicChecks.vue?vue&type=template&id=d99ef35c&scoped=true"
import script from "./AcademicChecks.vue?vue&type=script&lang=js"
export * from "./AcademicChecks.vue?vue&type=script&lang=js"

import "./AcademicChecks.vue?vue&type=style&index=0&id=d99ef35c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99ef35c"]])

export default __exports__